import {
  SHOW_CALLOUT,
  HIDE_CALLOUT,
  SHOW_ERROR,
  TOGGLE_MOBILE_NAV,
  SET_EDITOR_MODE,
  EDITOR_MODES,
  UNLOAD_PLAYBACK,
  LOAD_PLAYBACK,
  LOADED_PLAYBACK_ASSETS,
  UI_LOADING,
  CURRENT_HOME_VIEW,
  AUDIO_RECORDING_START,
  AUDIO_RECORDING_CANCEL,
  SHOW_RECORD_PANEL,
  CURRENT_EDIT_ANIMATION_TAB
} from '../actionCreators/uiActions';
import { RESET_STATE } from '../actionCreators/generalActions';
import { LOAD_ALL_FONTS_SUCCESS } from '../actionCreators/fontActions';
import { EDITOR_SET_EDIT_PANEL_MODE } from '../actionCreators/editorActions';
import { SAVE_AUDIO, SAVE_AUDIO_SUCCESS, SAVE_AUDIO_FAILED } from '../actionCreators/scribeActions';
import {
  LOAD_IMAGE_CROP,
  CANCEL_IMAGE_CROP,
  CONFIRM_IMAGE_CROP,
  START_IMAGE_CROP,
  CONFIRM_IMAGE_CROP_SUCCESS,
  CONFIRM_IMAGE_CROP_FAILED
} from '../actionCreators/croppingActions';

const initialState = {
  showCallout: null,
  showMobileNav: false,
  editorMode: EDITOR_MODES.default,
  isLoadingPlayback: false,
  uiIsLoading: false,
  currentHomeView: 'templates',
  allFontsLoaded: false,
  editPanelMode: null,
  isSavingAudio: {},
  isAudioPanelBusy: false,
  currentEditAnimationTab: 'edit'
};

export default function uiReducers(state = initialState, action) {
  switch (action.type) {
    case SHOW_CALLOUT: {
      return {
        ...state,
        showCallout: action.callout
      };
    }

    case HIDE_CALLOUT: {
      return {
        ...state,
        showCallout: null
      };
    }

    case SHOW_ERROR: {
      return {
        ...state,
        showCallout: { title: action.error.message, details: action.error.description, isError: true }
      };
    }

    case RESET_STATE: {
      return {
        ...initialState
      };
    }

    case TOGGLE_MOBILE_NAV: {
      return {
        ...state,
        showMobileNav: !state.showMobileNav
      };
    }

    case SET_EDITOR_MODE: {
      return {
        ...state,
        editorMode: action.mode
      };
    }

    case UNLOAD_PLAYBACK: {
      return {
        ...state,
        isLoadingPlayback: false
      };
    }

    case LOAD_PLAYBACK: {
      return {
        ...state,
        isLoadingPlayback: action.showLoading
      };
    }

    case LOADED_PLAYBACK_ASSETS: {
      return {
        ...state,
        isLoadingPlayback: false
      };
    }

    case UI_LOADING: {
      return {
        ...state,
        uiIsLoading: action.isLoading
      };
    }

    case CURRENT_HOME_VIEW: {
      return {
        ...state,
        currentHomeView: action.currentHomeView
      };
    }

    case LOAD_ALL_FONTS_SUCCESS: {
      return {
        ...state,
        allFontsLoaded: true
      };
    }

    case EDITOR_SET_EDIT_PANEL_MODE: {
      return {
        ...state,
        editPanelMode: action.mode
      };
    }

    case SAVE_AUDIO: {
      return {
        ...state,
        isSavingAudio: {
          ...state.isSavingAudio,
          [action.audioType]: true
        },
        isAudioPanelBusy: true
      };
    }

    case SAVE_AUDIO_SUCCESS:
    case SAVE_AUDIO_FAILED: {
      return {
        ...state,
        isSavingAudio: {
          ...state.isSavingAudio,
          [action.audioType]: false
        },
        isAudioPanelBusy: false
      };
    }

    case SHOW_RECORD_PANEL:
    case AUDIO_RECORDING_START: {
      return {
        ...state,
        isAudioPanelBusy: true
      };
    }

    case AUDIO_RECORDING_CANCEL: {
      return {
        ...state,
        isAudioPanelBusy: false
      };
    }

    case START_IMAGE_CROP: {
      return {
        ...state,
        uiIsLoading: true
      };
    }

    case LOAD_IMAGE_CROP: {
      return {
        ...state,
        editorMode: EDITOR_MODES.IMAGE_CROP,
        uiIsLoading: false
      };
    }

    case CANCEL_IMAGE_CROP: {
      return {
        ...state,
        editorMode: EDITOR_MODES.default,
        uiIsLoading: false
      };
    }

    case CONFIRM_IMAGE_CROP: {
      return {
        ...state,
        uiIsLoading: true
      };
    }

    case CONFIRM_IMAGE_CROP_FAILED:
    case CONFIRM_IMAGE_CROP_SUCCESS: {
      return {
        ...state,
        editorMode: EDITOR_MODES.default,
        uiIsLoading: false
      };
    }

    case CURRENT_EDIT_ANIMATION_TAB: {
      return {
        ...state,
        currentEditAnimationTab: action.currentEditAnimationTab
      };
    }

    default:
      return state;
  }
}
